import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { message } from 'antd';
import baseuri from '../../baseuri';

export const getCommercialBanks = createAsyncThunk(
	'/commercialBank/getCommercialBanks',
	async (params: any) => {
		const res = await baseuri.get('/admin/commercial-banks', {
			params: { ...params },
		});

		return res.data.data;
	}
);

export const createCommercialBank = createAsyncThunk(
	'commercialBank/createCommercialBank',
	async (data: any) => {
		try {
			const res = await baseuri.post('/admin/commercial-banks', data);
			message.success(res.data.message);
			return res.data.data;
		} catch (e: any) {
			message.error(e.response.data.message);
			return false;
		}
	}
);

export const editCommercialBank = createAsyncThunk(
	'commercialBank/editCommercialBank',
	async ({ id, data }: { id: any; data: any }) => {
		try {
			const res = await baseuri.put(`/admin/commercial-banks/${id}`, data);
			message.success(res.data.message);
			return res.data.data;
		} catch (e: any) {
			message.error(e.response.data.message);
			return false;
		}
	}
);

export const deleteCommercialBank = createAsyncThunk(
	'commercialBank/deleteCommercialBank',
	async (id: any) => {
		try {
			const res = await baseuri.delete(`/admin/commercial-banks/${id}`);
			message.success(res.data.message);
			return res.data.data;
		} catch (e: any) {
			message.error(e.response.data.message);
			return false;
		}
	}
);

const commercialBankRx = createSlice({
	name: 'commercialBank',
	initialState: {
		commercialBanks: {
			itemsList: [],
			paginator: {
				currentPage: 0,
				perPage: 0,
				itemCount: 0,
				pageCount: 0,
			},
		},
	},
	reducers: {},
	extraReducers: (builder) =>
		builder.addCase(getCommercialBanks.fulfilled, (store, action) => {
			const state = store;
			state.commercialBanks = action.payload;
		}),
});

export default commercialBankRx.reducer;
